import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainingRecordDetailsComponent } from './components/training-record-details/training-record-details.component';
import { TrainingTypeEditorComponent } from './components/training-type-editor/training-type-editor.component';
import { TrainingRecordEditorComponent } from './components/training-record-editor/training-record-editor.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { TrainingRecordEditorModalComponent } from './components/training-record-editor-modal/training-record-editor-modal.component';
import { TrainingRecordDocumentsComponent } from './components/training-record-documents/training-record-documents.component';
import { RouterModule } from '@angular/router';
import { TrainingRecordDocumentsPageComponent } from './components/training-record-documents-page/training-record-documents-page.component';
import { ObservationModule } from '../observations/observation.module';
import { TrainingRecordDocumentDetailsPageComponent } from './components/training-record-document-details-page/training-record-document-details-page.component';
import { DocumentsModule } from '../documents/documents.module';
import { TableModule } from 'primeng/table';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { CommonsModule } from '../common/commons.module';
import { TabViewModule } from 'primeng/tabview';
import { TrainingTypeDocumentDetailsPageComponent } from './components/training-type-document-details-page/training-type-document-details-page.component';

@NgModule({
  declarations: [TrainingRecordDetailsComponent,
    TrainingTypeEditorComponent,
    TrainingRecordEditorComponent,
    TrainingRecordEditorModalComponent,
    TrainingRecordDocumentsComponent,
    TrainingRecordDocumentsPageComponent,
    TrainingRecordDocumentDetailsPageComponent,
    TrainingTypeDocumentDetailsPageComponent
  ],

  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TableModule,
    RouterModule,
    ObservationModule,
    DocumentsModule,
    InputTextareaModule,
    InputTextModule,
    CommonsModule,
    TabViewModule
  ],

  exports: [
    TrainingTypeEditorComponent, TrainingRecordEditorModalComponent
  ]
})

export class TrainingRecordsModule { }
